import { render, staticRenderFns } from "./TestTwo.vue?vue&type=template&id=25b3917a&scoped=true&"
import script from "./TestTwo.vue?vue&type=script&lang=js&"
export * from "./TestTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b3917a",
  null
  
)

export default component.exports